import { Box, FormControlLabel, Switch, TextField } from "@mui/material";
import { isNil } from "lodash-es";
import { type FC, useCallback, useMemo } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import type { PollWrapperSchema } from "./types";

export const PollHelperText: FC = () => {
  const { control, setValue, getValues } = useFormContext<PollWrapperSchema>();

  useWatch({ control, name: "poll.helper_text" });
  const helper_text = getValues("poll.helper_text");

  const showHelperText = useMemo(() => !isNil(helper_text), [helper_text]);

  const handleToggle = useCallback(
    (checked: boolean) => {
      if (checked) {
        setValue("poll.helper_text", "");
      } else {
        setValue("poll.helper_text", undefined);
      }
    },
    [setValue],
  );

  return (
    <Box>
      <FormControlLabel
        control={
          <Switch checked={showHelperText} onChange={(e) => handleToggle(e.target.checked)} />
        }
        label="Show Helper Text"
      />

      {showHelperText && (
        <Controller
          name="poll.helper_text"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Helper Text"
              fullWidth
              multiline
              value={field.value ?? ""}
            />
          )}
        />
      )}
    </Box>
  );
};
